import { app_mst_role_ext_RowInterface, app_mst_role_line_RowInterface, app_mst_role_RowClass } from "../../dbschema";

export class TenantRoleContainerModel {
    app_mst_role: app_mst_role_RowClass = new app_mst_role_RowClass();
    app_mst_role_exts: Array<app_mst_role_ext_RowInterface> = [];
    app_mst_role_lines: Array<app_mst_role_line_RowInterface> = [];
}